import { useLinesMyTvStore } from "@/stores/LinesMyTv";

const MyTvStoreModule = useLinesMyTvStore();
const {
    fetchMyTvOnDemand,
    fetchMyTvPrograms,
	fetchMyTvChannels
} = MyTvStoreModule;


export default defineNuxtRouteMiddleware(() => {
	if (import.meta.client) {

		void fetchMyTvChannels();

		void fetchMyTvOnDemand();

		void fetchMyTvPrograms();
	}
});